import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const OvalIcon = ({...props}) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <path
                d="M19.9997 38.0622C29.9752 38.0622 38.0619 29.9755 38.0619 20C38.0619 10.0245 29.9752 1.93781 19.9997 1.93781C10.0242 1.93781 1.9375 10.0245 1.9375 20C1.9375 29.9755 10.0242 38.0622 19.9997 38.0622Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9997 35.0622C28.3183 35.0622 35.0619 28.3186 35.0619 20C35.0619 11.6814 28.3183 4.93781 19.9997 4.93781C11.6811 4.93781 4.9375 11.6814 4.9375 20C4.9375 28.3186 11.6811 35.0622 19.9997 35.0622ZM38.0619 20C38.0619 29.9755 29.9752 38.0622 19.9997 38.0622C10.0242 38.0622 1.9375 29.9755 1.9375 20C1.9375 10.0245 10.0242 1.93781 19.9997 1.93781C29.9752 1.93781 38.0619 10.0245 38.0619 20Z"
                fill="black"
            />
        </Icon>
    )
}

OvalIcon.propTypes = {
    secondaryColor: PropTypes.string,
}

export default OvalIcon
